<template>
    <v-container fluid class="pa-0 my-5">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <h6 class="my-3">{{ $t('partner.job.attachments') }}</h6>
            </v-col>
            <v-col cols="0" class="px-3">
                <v-progress-linear v-if="loading" indeterminate color="primary" height="2">
                </v-progress-linear>
                <v-divider v-else>
                </v-divider>
            </v-col>
            <v-col v-if="!loading" cols="auto">
                <v-btn icon="mdi-paperclip-plus" variant="text" size="small" color="success" class="attachment-add-btn"
                    @click="clickFileInput()">
                </v-btn>
            </v-col>
        </v-row>
        <DropPad width="100%" align="stratch" justify="start" multiple @fileDrop="handleFileDrop"
            @click="clickFileInput()">
            <v-file-input v-show="false" v-model="uploadFiles" ref="fileinput" color="primary" multiple="multiple">
                <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="primary" dark label>
                        {{ text }}
                    </v-chip>
                </template>
            </v-file-input>

            <v-list v-if="files && files.length" class="py-0" @click.stop="">
                <File v-for="(file, index) in files" :key="'file-' + index" :file="file" :deleteFunc="deleteAttachment">
                </File>
            </v-list>

            <div v-else-if="!loading">
                {{ $t('partner.job.no_attachments') }}
            </div>
        </DropPad>
        <v-row no-gutters class="mt-3">
            <v-col cols="auto">
                <DownloadServiceReportBtn :job="job">
                </DownloadServiceReportBtn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="offlineEnabled" cols="auto">
                <OfflinePdfDialog :job="job" :readonly="readonly" @Refresh="$emit('Refresh')">
                </OfflinePdfDialog>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import http from "@/api/client";
import File from "@/components/ListItems/File.vue";
import DropPad from "@/components/Cards/DropPad.vue";
import OfflinePdfDialog from "@/components/Dialogs/OfflinePdfDialog.vue";
import DownloadServiceReportBtn from "@/components/DownloadServiceReportBtn.vue";

export default {
    name: 'Attachments',
    props: {
        jobId: Number,
        job: Object,
        readonly: Boolean,
    },
    components: {
        File,
        DropPad,
        OfflinePdfDialog,
        DownloadServiceReportBtn,
    },

    data() {
        return {
            uploadFiles: null,
            files: [],
            loading: false,
            offlineEnabled: false,
        };
    },

    mounted() {
        this.getOfflineReportEnabled();
        this.getAttachments();
    },

    methods: {
        clickFileInput() {
            if (this.readonly) {
                return;
            }

            const fileInputComponent = this.$refs.fileinput;
            const nativeInput = fileInputComponent?.$el?.querySelector('input[type="file"]');
            nativeInput?.click();
        },

        handleFileDrop(files) {
            if (!this.readonly) {
                this.uploadFiles = files;
            }
        },

        getAttachments() {
            if (this.jobId) {
                this.loading = true;
                return http()
                    .get(`api2/partner/jobs/${this.jobId}/Attachments`)
                    .then((response) => {
                        this.files = response.data?.Files;
                        this.loading = false;
                    });
            }
        },

        async uploadAttachments() {
            var files = this.uploadFiles;
            if (files && files.length) {
                this.loading = true;
                let formData = new FormData();
                for (var filekey in files) {
                    if (Object.prototype.hasOwnProperty.call(files, filekey)) {
                        const file = files[filekey];
                        formData.append("Files", file, file.name);
                    }
                }
                await http()
                    .post(`api2/partner/jobs/${this.jobId}/Attachments`, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                        transformRequest: formData => formData
                    })
                    .then((response) => {
                        this.files = response.data?.Files;
                    })
                    .finally(() => {
                        this.uploadFiles = null;
                        this.loading = false;
                    });
            }
        },

        deleteAttachment(file) {
            this.loading = true;
            return http()
                .delete(`api2/partner/jobs/${this.jobId}/Attachment/${file.Id}`)
                .then((response) => {
                    this.files = response.data?.Files;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async getOfflineReportEnabled() {
            this.offlineEnabled = await http()
                .get(`api2/partner/jobs/offlinereport-enabled`)
                .then(response => response.data)
                .catch(() => false);
        },
    },

    computed: {},

    watch: {
        jobId() {
            this.getAttachments();
        },

        uploadFiles: function (val) {
            this.uploadAttachments(val);
        },
    },
};
</script>


<style lang='scss' scoped>
.attachment-add-btn {
    background: transparent !important;
    box-shadow: none !important;
}
</style>